import "core-js/modules/es.regexp.exec.js";
import { showToast } from 'vant';
import 'vant/es/toast/style';
import 'vant/es/popup/style';
import VerticalSwiper from '../../components/VerticalSwiper.vue';
import Privacy from '../../components/Privacy.vue';
import ServiceContract from '../../components/ServiceContract.vue';
import officialSwiper1 from '../../assets/officialSwiper1.png';
import officialSwiper2 from '../../assets/officialSwiper2.png';
import officialSwiper3 from '../../assets/officialSwiper3.png';
import groupScan from '../../assets/groupScan.png';
import appScan from '../../assets/appScan.png';
import logo from '../../assets/logo.png';
import arrowUpRight from '../../assets/arrowUpRight.png';
import contactBg from '../../assets/contactBg.png';
import ioslogo from '../../assets/ioslogo.png';
import androidlogo from '../../assets/androidlogo.png';
import downtips from '../../assets/downtips.png';
/**
 * 官方页面组件
 * @component Official
 * @description 起泡AI官方页面，包含视频背景、精选模版轮播、联系方式和页脚
 */
export default {
  name: 'Official',
  components: {
    VerticalSwiper: VerticalSwiper,
    Privacy: Privacy,
    ServiceContract: ServiceContract
  },
  data: function data() {
    return {
      ioslogo: ioslogo,
      androidlogo: androidlogo,
      downtips: downtips,
      swiperImages: [officialSwiper1, officialSwiper2, officialSwiper3],
      groupScan: groupScan,
      appScan: appScan,
      logo: logo,
      arrowUpRight: arrowUpRight,
      contactBg: contactBg,
      showPrivacyModal: false,
      showTermsModal: false,
      showTips: false,
      androidUrl: 'https://app.facepopo.com/qipaoMobile/qipao.apk',
      iosUrl: 'https://apps.apple.com/app/id6757213671'
    };
  },
  methods: {
    goPrivary: function goPrivary() {
      this.$router.push({
        path: '/privary'
      });
    },
    isWeChat: function isWeChat() {
      return /micromessenger/i.test(navigator.userAgent || '');
    },
    /**
     * iOS 下载点击处理
     * 在微信环境下显示提示，其他环境正常跳转到 App Store
     */
    onIosClick: function onIosClick(e) {
      if (this.isWeChat()) {
        e.preventDefault();
        showToast('请在浏览器中打开或复制链接到浏览器');
        this.showTips = true;
      }
      // 非微信环境允许正常跳转到 App Store
    },
    onAndroidClick: function onAndroidClick(e) {
      if (this.isWeChat()) {
        e.preventDefault();
        this.showTips = true;
      }
    }
  }
};